import { Paper, FormGroup, Button, InputLabel, FormControl, Select, MenuItem, FormControlLabel, TextField, Checkbox} from "@material-ui/core"
import { makeStyles} from '@material-ui/core/styles';
import { useState,  useEffect } from "react";
import { fetchEmployees, fetchDest, updateRulesdata, fetchRules, leadassignment, newleadassignment, fetchOpenCustomers} from "../api/customerapi";
import { v4 as uuidv4 } from "uuid";
import GetRole from "./user";
import {preventDoubleClick} from "./preventDC.js"
import { useAppData } from "./appDataContext.js";
import {BlinkingText} from "./date.js"

const useStyles = makeStyles((theme) => ({
    paper: {
      marginLeft: theme.spacing(10),
      marginRight: theme.spacing(10),
      marginBottom: theme.spacing(5),
      marginTop: theme.spacing(4),
      justifyContent: "center",
      backgroundColor: "#f8f8f8"
    },
   
    headertext: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
        marginLeft: theme.spacing(3),
    },
    button: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        width: theme.spacing(14),
        height: theme.spacing(5),
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
        fontSize: 10
      },
    formgroup: {
        justifyContent: "center",  
        alignContent: "center", 
    }, 
    textField: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(4),
        width: theme.spacing(40),
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
      },
  }));

const LeadRules=()=>{
    const classes = useStyles();
    const [leadrules, setleadrules] = useState([{
      destinations:[],
      preserve_trips:false,
    }]);
    var { cuser, role } = GetRole();
    const [newleadrules, setnewleadrules] = useState([]);
    const [splist, setsplist] = useState([]);
    const [tllist, settllist] = useState([]);
    const [dest, setdest] = useState([]);
    const [response, setresponse] = useState([]);
     const [masterChangeLog, setMasterChangeLog] = useState([]); // last 5 save operations
     const [filterData, setfilterData] = useState([]);
     const { appData, loading } = useAppData();

    useEffect(() => {
        getEmployees()
        getDest() 
        getRules()
      }, []);

      const getEmployees = async () => {
        try{
        var data= await fetchEmployees();
        const empsplist = data.data.filter((emp) => emp.role == "Sales" || emp.role == "SME");
        const empsplist2 = data.data.filter((emp) => emp.role == "TL");
        //const empsplist = data.data.filter((emp) => emp.role == "Sales" || emp.role == "TL");
        var empshortname = empsplist.map((emp) => emp.short_name);
        var empshortname2 = empsplist2.map((emp) => emp.short_name);
        if(empshortname.length==0){
          empshortname=["Amit"]
        }
        if(empshortname2.length==0){
          empshortname2=["Amit"]
        }
        let sortedemp = empshortname.sort()
    //setemp(sortedemp);
        setsplist(sortedemp);
        settllist(empshortname2);
      }catch(err){
        console.log(err)
      }
      };

      const getDest = async () => {
        try{
        const data = await fetchDest();
        const temp=data.data.filter(d=>"order" in d)
        setdest(temp[0].dest);
      }catch(err){
        console.log(err)
      }
      }

      const getRules = async () => {
        try{
        const data = await fetchRules();
        setresponse(data.data[0])
        setleadrules(data.data[0].leadrule);
        setnewleadrules(data.data[0].newleadrule);
        setMasterChangeLog(Array.isArray(data.data[0].master_change_log) ? data.data[0].master_change_log : []);
      }catch(err){
        console.log(err)
      }
      };


      const addday = (index) => {
        //console.log(cpdata)
      var temp2=[...leadrules]
        // setleadrules(
        //   leadrules.length == 0
        //     ? [{ id: uuidv4(), destinations:[] }]
        //     : [...leadrules, { id: uuidv4(), destinations:[] }]
        // );

        const temp =  [
  ...temp2.slice(0, index+1), // part before the index
  { id: uuidv4(), destinations:[] },               // inserted item
  ...temp2.slice(index+1)    // part after the index
];
  setleadrules(temp)
      };
    
      const removeday = (indexToRemove) => {
        //console.log(cpdata)
        //setleadrules([...leadrules].slice(0, leadrules.length - 1));
         var temp2=[...leadrules]
      const newArray = temp2.filter((_, index) => index !== indexToRemove)

      
  
      setleadrules(newArray)
      };

    //  const updateNthElement = (index, newValue) => {
    //     setleadrules(prevItems =>
    //         prevItems.map((item, i) => (i === index ? newValue : item))
    //     );
    // }; 

      const adddest = (index) => {
        const temprule="new_destinations" in leadrules[index]?leadrules[index].new_destinations:[]
        const temp={id: uuidv4()}
        const temp2={...leadrules[index], new_destinations:[...temprule, temp]}
        
        // updateNthElement(index, temp2)
        setleadrules(prevItems =>
          prevItems.map((item, i) => (i === index ? temp2 : item))
      );
        
      };

    
    
      const removedest = (index) => {
        const temprule="new_destinations" in leadrules[index]?leadrules[index].new_destinations:[]
        if(temprule.length>0){
        const temp2={...leadrules[index], new_destinations:temprule.slice(0, temprule.length - 1)}
        setleadrules(prevItems =>
          prevItems.map((item, i) => (i === index ? temp2 : item))
      );
        }
      };

      //console.log(leadrules)

      // Builds the updated change_log for a salesperson's record.
      // Stores the salesperson the change is for, what changed (field/from/to),
      // and who changed it (cuser). No size limit - this accumulates every change
      // made since the last save; it is bundled into the master log on save.
      const trackChange = (record, field, oldValue, newValue) => {
        const existinglog = Array.isArray(record.change_log) ? record.change_log : [];
        const entry = {
          salesperson: record.name,           // salesperson whose record was changed
          field,                              // which property was changed
          from: oldValue,                     // previous value
          to: newValue,                       // new value
          changed_by: cuser,                  // person making the change
          changed_at: new Date().toISOString(),
        };
        return [...existinglog, entry];       // keep the full history (no size limit)
      };

      const availabilitychange = (e, tid, id) => {
        const newdata = leadrules[tid];
        //console.log(newdata)
        const newitem = {
          ...newdata,
          availability: e.target.value,
          change_log: trackChange(newdata, "availability", newdata.availability, e.target.value),
        };
        //console.log(newitem)
        leadrules[tid] = newitem;
        setleadrules(leadrules.map((item) => (item.id == id ? newitem : item)));

      };
    
      const capacitychange = (e, tid, id) => {
        const newdata = leadrules[tid];
        //console.log(newdata)
        const newitem = {
          ...newdata,
          capacity: e.target.value,
          change_log: trackChange(newdata, "capacity", newdata.capacity, e.target.value),
        };
        //console.log(newitem)
        leadrules[tid] = newitem;
        setleadrules(leadrules.map((item) => (item.id == id ? newitem : item)));

      };

      const namechange = (e, tid, id) => {
        const newdata = leadrules[tid];
        //console.log(newdata)
        const newitem = {
          ...newdata,
          name: e.target.value,
          change_log: trackChange(newdata, "name", newdata.name, e.target.value),
        };
        //console.log(newitem)
        leadrules[tid] = newitem;
        setleadrules(leadrules.map((item) => (item.id == id ? newitem : item)));

      };

      const tlchange = (e, tid, id) => {
        const newdata = leadrules[tid];
        //console.log(newdata)
        const newitem = {
          ...newdata,
          tl: e.target.value,
          change_log: trackChange(newdata, "tl", newdata.tl, e.target.value),
        };
        //console.log(newitem)
        leadrules[tid] = newitem;
        setleadrules(leadrules.map((item) => (item.id == id ? newitem : item)));

      };

      const destinationschange = (e, tid, id) => {
        const newdata = leadrules[tid];
        const temp=Array.isArray(e.target.value)?e.target.value:[e.target.value]
        const newitem = {
          ...newdata,
          destinations: temp,
          change_log: trackChange(newdata, "destinations", newdata.destinations, temp),
        };
        //console.log(newitem)
        leadrules[tid] = newitem;
        setleadrules(leadrules.map((item) => (item.id == id ? newitem : item)));

      };

      const assignchange = (e, tid, id) => {
        const newdata = leadrules[tid];
        //console.log(newdata)
        const newitem = {
          ...newdata,
          preserve_trips: e.target.checked,
          change_log: trackChange(newdata, "preserve_trips", newdata.preserve_trips, e.target.checked),
        };
        //console.log(newitem)
        leadrules[tid] = newitem;
        setleadrules(leadrules.map((item) => (item.id == id ? newitem : item)));

      };

      const hqchange = (e, tid, id) => {
        const newdata = leadrules[tid];
        //console.log(newdata)
        const newitem = {
          ...newdata,
          hq: e.target.checked,
          change_log: trackChange(newdata, "hq", newdata.hq, e.target.checked),
        };
        //console.log(newitem)
        leadrules[tid] = newitem;
        setleadrules(leadrules.map((item) => (item.id == id ? newitem : item)));

      };

      const leadassign=async()=>{
            try{
            const data=await leadassignment()
            if(data.status == 200 || 201 || 202|| 203|| 204|| 205 || 206 || 207){
              
              alert(data.data)
              window.location = ("/leadrules");
          }
          else{
              alert("Something went wrong. Contact support");
              
          }
          }catch(err){
            console.log(err)
          }
        }

        const newleadassign=async()=>{
          try{
          const data2 = await fetchOpenCustomers();
          const temp=data2.data.filter(c=> c.follow_up.owner=="RohitS" || c.follow_up.owner=="Amit" || c.follow_up.owner=="Sidharth" || c.follow_up.owner=="Hitesh" || c.follow_up.owner=="Rana" || c.follow_up.owner=="Asgar" || c.follow_up.owner=="Yadvinder" || c.follow_up.owner=="HarshB" || c.follow_up.owner=="NitinK" || c.follow_up.owner=="Quasain" || c.follow_up.owner=="Tulsi" || c.follow_up.owner=="Manish")
          console.log(temp.length)
          if(temp.length>10){
            alert("Cannot run. Clear customer fups first")
          }else{
          const data=await newleadassignment()
          if(data.status == 200 || 201 || 202|| 203|| 204|| 205 || 206 || 207){
              
                alert("Lead distributed successfully")
                console.log(data.data)
                window.location = ("/leadrules");
            }
            else{
                alert("Something went wrong. Contact support");
                
            }
          }
        }catch(err){
          console.log(err)
        }
      }

    const updaterules=async()=>{
        //console.log(leadrules)
        try{
        // Collect every change accumulated across all salesperson records since the last save.
        const changesThisSave = leadrules.flatMap(sp => Array.isArray(sp.change_log) ? sp.change_log : []);

        // One object per save operation, holding the entire change log for that save.
        const saveEntry = {
          saved_by: cuser,                      // person who performed the save
          saved_at: new Date().toISOString(),
          changes: changesThisSave,             // the whole change log bundled together
        };

        // Master log keeps only the last 5 save operations.
        const updatedMasterLog = [...masterChangeLog, saveEntry].slice(-5);
        setMasterChangeLog(updatedMasterLog);

        // Reset each record's change_log so the next save starts a fresh batch.
        const clearedleadrules = leadrules.map(sp => ({ ...sp, change_log: [] }));
        setleadrules(clearedleadrules);
        console.log(clearedleadrules)
        console.log(updatedMasterLog)
        const rulesupdate=await updateRulesdata(response._id, clearedleadrules, updatedMasterLog)
        if (
          rulesupdate.status == 200 ||
          201 ||
          202 ||
          203 ||
          204 ||
          205 ||
          206 ||
          207
        ) {
          alert(
            "Rules data updated"
          );
          window.location = ("/leadrules");
        } else {
          alert("Something went wrong. Contact support");
          window.location = "/";
        }
      }catch(err){
        console.log(err)
      }
    }

    const newdestinationschange = (e, tid, sid, id) => {
      //console.log(tid, sid)
      const temp={...leadrules[tid].new_destinations[sid], dest:e.target.value}
      //console.log(temp)
      const newitem = { ...leadrules[tid], new_destinations: leadrules[tid].new_destinations.map((item) => (item.id == id ? temp : item)) };
      //console.log(newitem)
      //leadrules[tid] = newitem;
      setleadrules(prevItems =>
        prevItems.map((item, i) => (i === tid ? newitem : item))
    );

    };

    const newcapacitychange = (e, tid, sid, id) => {
      //console.log(tid, sid)
      const temp={...leadrules[tid].new_destinations[sid], capacity:e.target.value}
      //console.log(temp)
      const newitem = { ...leadrules[tid], new_destinations: leadrules[tid].new_destinations.map((item) => (item.id == id ? temp : item)) };
      //console.log(newitem)
      //leadrules[tid] = newitem;
      setleadrules(prevItems =>
        prevItems.map((item, i) => (i === tid ? newitem : item))
    );

    };

    


    var l1=[...leadrules]
    if(filterData.tl){
      l1=l1.filter(sp=>sp.tl==filterData.tl)
      // console.log(temp)
      // setleadrules(temp)
    }
   //console.log(l1)
    return ( 
      <div>
      {role && role!=="Sales"?(
        <Paper variant="outlined" className={classes.paper} elevation={10}> 
         <div align="center">
         <BlinkingText>CRM now keeps track of all changes made in SetRules</BlinkingText>
         <FormControl style={{minWidth: 480, marginTop: 16, marginRight: 32, marginLeft: 8}}>
                    <InputLabel id="tl">TL</InputLabel>
                        <Select displayEmpty classname={classes.textField} labelId="tl" InputLabelProps={{ shrink: true }}  onChange={(e)=> setfilterData({...filterData, tl:e.target.value})}>
                        <MenuItem value={""}>Clear</MenuItem>
                        {tllist.map(emp => {
                          return <MenuItem value={emp}>{emp}</MenuItem>})}
                          
                        </Select>
                        </FormControl>
         </div>
        {l1 && l1.length>0 && l1.map(sp=><div>
            <FormGroup row className={classes.formgroup}>
            <FormControl
              style={{
                minWidth: 160,
                marginTop: 16,
                marginRight: 32,
                marginLeft: 32,
              }}
            >
              <InputLabel id="name">Name?</InputLabel>
              <Select
                InputLabelProps={{ shrink: true }} 
                classname={classes.textField}
                labelId="name"
                name={leadrules.indexOf(sp)}
                value={"name" in sp?sp.name:""}
                onChange={(e) => namechange(e, e.target.name, sp.id)}
              >
               {/* <MenuItem value={"Amit"}>Amit</MenuItem>
               <MenuItem value={"Asgar"}>Asgar</MenuItem> */}
                    {splist.map(d=>
                    <MenuItem key={d} value={d}>
                        {/* <Checkbox checked={dest.indexOf(d) > -1} /> */}
                         {d}
                    </MenuItem> 
                 )} 

              </Select>
            </FormControl>  
            <FormControl
              style={{
                minWidth: 160,
                marginTop: 16,
                marginRight: 32,
                marginLeft: 32,
              }}
            >
              <InputLabel id="available">Available?</InputLabel>
              <Select
             InputLabelProps={{ shrink: true }} 
                classname={classes.textField}
                labelId="available"
                name={leadrules.indexOf(sp)}
                value={"availability" in sp?sp.availability:""}
                onChange={(e) => availabilitychange(e, e.target.name, sp.id)}
              >
                    <MenuItem value={"No"}>No</MenuItem>
                    <MenuItem value={"Yes"}>Yes</MenuItem>

              </Select>
            </FormControl>  
            
            <FormControl
              style={{
                minWidth: 160,
                marginTop: 16,
                marginRight: 32,
                marginLeft: 32,
              }}
            >
              <InputLabel id="destinations">Destinations? (for manual assign)</InputLabel>
              <Select
               InputLabelProps={{ shrink: true }} 
                classname={classes.textField}
                multiple
                labelId="destinations"
                name={leadrules.indexOf(sp)}
                value={sp.destinations}
                onChange={(e) => destinationschange(e, e.target.name, sp.id)}
              >
               <MenuItem value={"Bali"}>Bali</MenuItem>
                 {dest.map(d=>
                    <MenuItem key={d} value={d}>
                        {/* <Checkbox checked={dest.indexOf(d) > -1} /> */}
                         {d}
                    </MenuItem> 
                 )}   

              </Select>
            </FormControl> 
            <FormControlLabel control={<Checkbox color="primary"/>}  name={leadrules.indexOf(sp)} checked={sp.preserve_trips} label="Do not re-assign" onChange={(e)=> assignchange(e, e.target.name, sp.id)}/>
             <FormControlLabel control={<Checkbox color="primary"/>}  name={leadrules.indexOf(sp)} checked={sp.hq} label="HQ?" onChange={(e)=> hqchange(e, e.target.name, sp.id)}/>
            </FormGroup>
            <FormGroup row className={classes.formgroup}>
            <FormControl
              style={{
                minWidth: 160,
                marginTop: 16,
                marginRight: 32,
                marginLeft: 32,
              }}
            >
              <InputLabel id="capacity">Capacity?</InputLabel>
              <Select
                InputLabelProps={{ shrink: true }} 
                classname={classes.textField}
                labelId="capacity"
                name={leadrules.indexOf(sp)}
                value={"capacity" in sp?sp.capacity:""}
                onChange={(e) => capacitychange(e, e.target.name, sp.id)}
              >
                    <MenuItem value={1}>1</MenuItem>
                    <MenuItem value={2}>2</MenuItem>
                    <MenuItem value={3}>3</MenuItem>
                    <MenuItem value={4}>4</MenuItem>
                    <MenuItem value={5}>5</MenuItem>
                    <MenuItem value={6}>6</MenuItem>
                    <MenuItem value={7}>7</MenuItem>
                    <MenuItem value={8}>8</MenuItem>
                    <MenuItem value={9}>9</MenuItem>
                    <MenuItem value={10}>10</MenuItem>
                    <MenuItem value={11}>11</MenuItem>
                    <MenuItem value={12}>12</MenuItem>
                    <MenuItem value={13}>13</MenuItem>
                    <MenuItem value={14}>14</MenuItem>
                    <MenuItem value={15}>15</MenuItem>
                    <MenuItem value={16}>16</MenuItem>
                    <MenuItem value={17}>17</MenuItem>
                    <MenuItem value={18}>18</MenuItem>
                    <MenuItem value={19}>19</MenuItem>
                    <MenuItem value={20}>20</MenuItem>

              </Select>
            </FormControl> 
            <TextField
                variant="standard"
                InputLabelProps={{ shrink: true }} 
                label="Used Capacity"
                value={sp.capacity_used}
                className={classes.textField}
                disabled
              />
          <TextField
                variant="standard"
                InputLabelProps={{ shrink: true }} 
                label="Remaining Capacity"
                value={sp.capacity-sp.capacity_used}
                className={classes.textField}
                disabled
              />
              <FormControl
              style={{
                minWidth: 160,
                marginTop: 16,
                marginRight: 32,
                marginLeft: 32,
              }}
            >
              <InputLabel id="tl">TL?</InputLabel>
              <Select
                InputLabelProps={{ shrink: true }} 
                classname={classes.textField}
                labelId="tl"
                name={leadrules.indexOf(sp)}
                value={"tl" in sp?sp.tl:""}
                onChange={(e) => tlchange(e, e.target.name, sp.id)}
              >
                    {tllist.map(d=>
                    <MenuItem key={d} value={d}>
                        {/* <Checkbox checked={dest.indexOf(d) > -1} /> */}
                         {d}
                    </MenuItem> 
                 )} 

              </Select>
            </FormControl> 
           
            </FormGroup>
            <br></br>
            {"new_destinations" in sp && sp.new_destinations.length>0?(<div>
            {sp.new_destinations.map(data=><div>
              <FormGroup row className={classes.formgroup}>
              <FormControl
              style={{
                minWidth: 160,
                marginTop: 16,
                marginRight: 32,
                marginLeft: 32,
              }}
            >
              <InputLabel id="newdestinations">Destinations?</InputLabel>
              <Select
               InputLabelProps={{ shrink: true }} 
                classname={classes.textField}
                labelId="newdestinations"
                name={sp.new_destinations.indexOf(data)}
                value={"dest" in data?data.dest:""}
                onChange={(e) => newdestinationschange(e, leadrules.indexOf(sp), e.target.name, data.id)}
              >
               <MenuItem value={"Bali"}>Bali</MenuItem>
                 {dest.map(d=>
                    <MenuItem key={d} value={d}>
                        {/* <Checkbox checked={dest.indexOf(d) > -1} /> */}
                         {d}
                    </MenuItem> 
                 )}   

              </Select>
            </FormControl> 
            <FormControl
              style={{
                minWidth: 160,
                marginTop: 16,
                marginRight: 32,
                marginLeft: 32,
              }}
            >
              <InputLabel id="newcapacity">Capacity?</InputLabel>
              <Select
                InputLabelProps={{ shrink: true }} 
                classname={classes.textField}
                labelId="newcapacity"
                name={sp.new_destinations.indexOf(data)}
                value={"capacity" in data?data.capacity:""}
                onChange={(e) => newcapacitychange(e, leadrules.indexOf(sp), e.target.name, data.id)}
              >
                    <MenuItem value={1}>1</MenuItem>
                    <MenuItem value={2}>2</MenuItem>
                    <MenuItem value={3}>3</MenuItem>
                    <MenuItem value={4}>4</MenuItem>
                    <MenuItem value={5}>5</MenuItem>
                    <MenuItem value={6}>6</MenuItem>
                    <MenuItem value={7}>7</MenuItem>
                    <MenuItem value={8}>8</MenuItem>
                    <MenuItem value={9}>9</MenuItem>
                    <MenuItem value={10}>10</MenuItem>
                    <MenuItem value={11}>11</MenuItem>
                    <MenuItem value={12}>12</MenuItem>
                    <MenuItem value={13}>13</MenuItem>
                    <MenuItem value={14}>14</MenuItem>
                    <MenuItem value={15}>15</MenuItem>
                    <MenuItem value={16}>16</MenuItem>
                    <MenuItem value={17}>17</MenuItem>
                    <MenuItem value={18}>18</MenuItem>
                    <MenuItem value={19}>19</MenuItem>
                    <MenuItem value={20}>20</MenuItem>

              </Select>
            </FormControl> 
            <TextField
                variant="standard"
                InputLabelProps={{ shrink: true }} 
                label="Used Capacity"
                value={"capacity_used" in data?data.capacity_used:""}
                className={classes.textField}
                disabled
              />
          <TextField
                variant="standard"
                InputLabelProps={{ shrink: true }} 
                label="Remaining Capacity"
                value={"capacity_used" in data && "capacity" in data?data.capacity-data.capacity_used:""}
                className={classes.textField}
                disabled
              />
              </FormGroup>
              </div>)}
              </div>
            ):("")}
            <FormGroup row className={classes.formgroup}>
            <Button
              variant="outlined"
              color="primary"
              className={classes.button}
              onClick={()=>adddest(leadrules.indexOf(sp))}
            >
              {" "}
              + Tranche
            </Button>
            {role=="Admin"?(
            <Button
              variant="outlined"
              color="secondary"
              className={classes.button}
              onClick={()=>removedest(leadrules.indexOf(sp))}
            >
              {" "}
              - Tranche
            </Button>
            ):("")}
            </FormGroup>
            <br></br>
            
             <br></br>
            <hr></hr>
            <br></br>
            {l1.length==leadrules.length?(
            <FormGroup row className={classes.formgroup}>
            <Button
              variant="outlined"
              color="primary"
              className={classes.button}
              onClick={()=>addday(leadrules.indexOf(sp))}
            >
              {" "}
              + SP
            </Button>
            <Button
              variant="outlined"
              color="secondary"
              className={classes.button}
              onClick={()=>removeday(leadrules.indexOf(sp))}
            >
              {" "}
              - SP
            </Button>
            
          </FormGroup>
          ):("")}
        </div>)}
           
            <FormGroup row className={classes.formgroup}>
            <Button
              variant="contained"
              color="primary"
              onClick={()=>updaterules()}
              className={classes.button}
            >
              Save
            </Button>
            <Button
              href={"/listemployeedata"}
              variant="contained"
              color="secondary"
              className={classes.button}
            >
              Cancel
            </Button>
            <Button
                        onClick={preventDoubleClick(leadassign)}
                        color="secondary"
                        variant="contained"
                        className={classes.button}
                      >
                        Assign Leads
                      </Button> 
                      <Button
                        onClick={preventDoubleClick(newleadassign)}
                        color="secondary"
                        variant="contained"
                        className={classes.button}
                      >
                        Assign Leads-New
                      </Button> 
            </FormGroup>
        </Paper>
        ):("")}
        </div>
    )   
}

export default LeadRules;